__turbopack_context__.v({
  "accentLine": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__accentLine",
  "backdrop": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__backdrop",
  "buttonContainer": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__buttonContainer",
  "buttonText": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__buttonText",
  "callText": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__callText",
  "cancelButton": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__cancelButton",
  "content": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__content",
  "contentSection": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__contentSection",
  "description": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__description",
  "disclaimer": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__disclaimer",
  "enrollButton": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__enrollButton",
  "enrollmentCode": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__enrollmentCode",
  "modal": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__modal",
  "modalContainer": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__modalContainer",
  "modalContent": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__modalContent",
  "phoneIcon": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__phoneIcon",
  "phoneNumber": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__phoneNumber",
  "planName": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__planName",
  "title": "MedigapEnrollmentModal-module-scss-module__cKK1Ka__title",
});
